import { prefix } from '@/utils/open-url'
export default function(option) {
  const NotificationInstance = Notification || window.Notification
  if (NotificationInstance) {
    const permissionNow = NotificationInstance.permission
    if (permissionNow === 'granted') {
      //允许通知
      CreatNotification(option)
    } else if (permissionNow === 'denied') {
      // console.log('用户拒绝了你!!!')
    } else {
      setPermission()
    }
  }
  function setPermission() {
    //请求获取通知权限
    NotificationInstance.requestPermission(function(PERMISSION) {
      if (PERMISSION === 'granted') {
        CreatNotification(option)
      } else {
        // console.log('用户无情残忍的拒绝了你!!!')
      }
    })
  }
  function CreatNotification(option) {
    const n = new NotificationInstance(option.title || '', {
      body: option.body || '',
      tag: option.tag || '',
      icon: option.icon || 'https://t.ddky.com/logo.png',
      data: {
        url: (option.url && prefix + option.url) || ''
      },
      //是否不在屏幕上显示通知信息。非必须，默认为false表示要显示
      noscreen: false,
      //新通知出现是否覆盖旧的通知，覆盖（true）则永远只显示一条通知，不覆盖（false）则会多条通知重叠。非必须，默认为true
      renotify: false,
      sound: 'https://t.ddky.com/tip.mp3'
    })
    n.onshow = function() {
      // console.log('通知显示了！')
    }
    n.onclick = function() {
      //可以直接通过实例的方式获取data内自定义的数据
      //也可以通过访问回调参数e来获取data的数据
      window.open(n.data.url, '_blank')
      n.close()
    }
    n.onclose = function() {
      // console.log('你关闭了我！！！')
    }
    n.onerror = function(err) {
      // console.log('出错了，小伙子在检查一下吧')
      throw err
    }
    setTimeout(() => {
      n.close()
    }, 8000)
  }
}
